import Compressor from 'compressorjs'

const useImgResize = (props) => {
	return (async file => new Promise(resolve => {
		const { width, height } = props
		if(!width || !height) {
			return resolve(file)
		}
		new Compressor(file, {		// eslint-disable-line no-new
			minWidth: width,
			minHeight: height,
			maxWidth: width,
			maxHeight: height,
			convertSize: 1000000,
			drew(context, canvas) {	// add white space to fill image to desired resolution (width x height)
				const Image = context.getImageData(0, 0, context.canvas.width, context.canvas.height)
				const { width: imageWidth, height: imageHeight } = canvas
				canvas.width = width
				canvas.height = height
				context.fillStyle = '#fff'
				context.fillRect(0, 0, width, height)
				context.putImageData(Image, width / 2 - imageWidth / 2, height / 2 - imageHeight / 2)
			},
			success(res) {
				resolve(res)
			}
		})
	}))
}

export default useImgResize
